import SparkMD5 from 'spark-md5';

export const calculateFileMd5 = async (file: File) => {
  try {
    const arrayBuffer = await file.arrayBuffer();
    const md5 = SparkMD5.ArrayBuffer.hash(arrayBuffer);
    return md5;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to calculate MD5 hash', {
      fileName: file.name,
      error,
    });
    return '';
  }
};

export const calculateFileSha256 = async (file: File) => {
  const arrayBuffer = await file.arrayBuffer();
  const hashBuffer = await crypto.subtle.digest('SHA-256', arrayBuffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
  return hashHex;
};

export const base64Encode = (input: string): string => {
  return Buffer.from(input).toString('base64');
};

export const base64ToHex = (base64Str: string) =>
  Buffer.from(base64Str, 'base64').toString('hex');

export const parseJwt = (token: string) => {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) {
      return null;
    }
    const payload = parts[1];
    const decodedPayload = atob(payload!.replace(/-/g, '+').replace(/_/g, '/'));
    const parsedPayload = JSON.parse(decodedPayload) as Record<string, unknown>;
    return parsedPayload;
  } catch {
    return null;
  }
};
